document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("size-guide-modal");
    const img = document.getElementById("size-guide-img");
    const loading = document.getElementById("size-guide-loading");
    const closeBtn = document.querySelector(".size-guide-close");

    document.body.addEventListener("click", function (e) {
        if (e.target.classList.contains("size-guide-trigger") || 
            e.target.closest(".size-guide-trigger")) {
            
            e.preventDefault();
            
            const btn = e.target.classList.contains("size-guide-trigger") 
                ? e.target 
                : e.target.closest(".size-guide-trigger");
            
            // Reset
            img.style.display = "none";
            loading.style.display = "block";
            
            const imageSrc = btn.dataset.sizeGuideImage;
            
            if (imageSrc) {
                img.src = imageSrc;
                img.onload = function () {
                    loading.style.display = "none";
                    img.style.display = "block";
                };
            }
            
            modal.style.display = "block";
        }
    });

    closeBtn.addEventListener("click", function () {
        modal.style.display = "none";
    });

    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            modal.style.display = "none";
        }
    });
});